angular.module('eCareVault.common.APIService', []);
